const styles = {
  root: {
    height: '100vh',
    boxSizing: 'border-box',
    overflow: 'auto',
    paddingBottom: 120,
  },
};

export default styles;
